<template>
  <div class="teacher_mien">
    <ul>
      <li>
        <span>所在学校</span>
        <div>{{params.school_name}}</div>
      </li>
      <li>
        <span>所在院系</span>
        <div>{{params.faculty}}</div>
      </li>
      <li>
        <span>研究方向</span>
        <div>{{params.research_direction}}</div>
      </li>
      <li>
        <span>个人简介</span>
        <div>{{params.synopsis}}</div>
      </li>
      <li>
        <span>获奖经历</span>
        <div>{{params.awards}}</div>
      </li>
      <li>
        <span>学术论著</span>
        <div>{{params.academic_work}}</div>
      </li>
      <!-- <li>
        <span>办公电话</span>
        <div>{{params.phone}}</div>
      </li>
      <li>
        <span>电子邮箱</span>
        <div>{{params.email}}</div>
      </li> -->
    </ul>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        params:{}
      }
    },
    created() {
      this.getData();
    },
    methods:{
      getData(){
        let params = {
          user: this.$route.query.user
        }
        this.api.getFrontTeachers(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.params = res.obj.list[0] || {};
        })
      }
    }
  }
</script>

<style lang="scss">
  .teacher_mien{
    background-color: #fff;
    margin-top: 20px;
    padding: 30px;
    margin-bottom: 20px;
    ul li{
      display: flex;
      margin-bottom: 20px;
      align-items: baseline;
      span{
        width: 110px;
        color: #999999;
      }
      div{
        flex: 1;
        color: #333;
        line-height: 20px;
      }
    }
  }
</style>
